import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'
import { TKeyMetricDataBody } from 'types/GlobalKeyMetric'

import {
  selectAvailableKeyMetrics,
  selectIsCreatingKeyMetric,
  selectKeyMetric,
  selectKeyMetricRawData,
  selectKeyMetricRawDataFetching,
  selectKeyMetrics
} from 'redux/selectors/KeyMetrics'

export const useKeyMetric = (id: string | null) => {
  return useSelector((state: ApplicationState) => selectKeyMetric(state, id))
}

export const useKeyMetrics = () => {
  return useSelector(selectKeyMetrics)
}

export const useAllKeyMetrics = () => {
  return useSelector(selectAvailableKeyMetrics)
}

export const useIsCreatingKeyMetric = () => {
  return useSelector(selectIsCreatingKeyMetric)
}

export const useKeyMetricRawData = (
  id: string,
  body?: TKeyMetricDataBody
) => {
  return useSelector((state: ApplicationState) =>
    selectKeyMetricRawData(state, id, body))
}

export const useKeyMetricRawDataFetching = (
  id: string,
  body?: TKeyMetricDataBody
) => {
  return useSelector((state: ApplicationState) =>
    selectKeyMetricRawDataFetching(state, id, body))
}
